/**
 * In local dev, MongoDB often points at production upload paths while files
 * live only on the production server. Do not hide those entries from public menus.
 */
export function shouldHideMissingDocument(doc) {
  if (!doc?.fileMissing) return false;
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return false;
  }
  return true;
}

export function filterDocumentsForPublicMenu(docs, { allowExternalUrl = false } = {}) {
  const list = Array.isArray(docs) ? docs : [];
  return list.filter((doc) => {
    if (allowExternalUrl && doc.externalUrl) return true;
    return !shouldHideMissingDocument(doc);
  });
}
